import { PropsWithChildren } from "react";

const RadioField: React.FC<
  PropsWithChildren<{
    id: string;
    name: string;
    value: string;
    checkedValue?: string;
    onChange?: (value: string) => void;
  }>
> = ({ id, name, value, checkedValue, onChange, children }) => (
  <div className="flex gap-1 pl-[5px]">
    <input
      id={id}
      type="radio"
      name={name}
      value={value}
      {...(onChange
        ? { checked: checkedValue === value, onChange: () => onChange(value) }
        : { defaultChecked: checkedValue === value })}
    />
    <label
      className="text-sm capitalize text-blue900"
      htmlFor={id}
    >
      {children}
    </label>
  </div>
);

export default RadioField;
